<template>
  <transition name="modal-info-fade">
    <div class="modal-info-backdrop">
      <div class="modal-info" :style="classe" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription" v-click-outside="onClickOutside">
        <header class="modal-info-header" id="modalTitle">
          <slot name="header"></slot>
        </header>
        <section class="modal-info-body" id="modalDescription">
          <slot name="body" @close="close()">I'm the default body!</slot>
        </section>
        <footer class="modal-info-footer">
          <slot name="footer">
            <!--             <button
              type="button"
              class="btn-green"
              @click="close"
              aria-label="Close modal"
            >Close me!</button>-->
          </slot>
        </footer>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "modal",
  props: {
    classe: String,
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onClickOutside() {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
.modal-info-backdrop {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: left;
  font-style: normal;
  font-weight: normal;
  font-family: "Poppins", sans-serif;
  z-index: 999999999;
}
.arrow {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 50px 86.6px 50px 0;
  border-color: transparent #2d3041 transparent transparent;
}

.modal-info-header,
.modal-info-body,
.modal-info-footer {
  padding-left: 15px;
  padding-right: 15px;
  display: flex;
}

.modal-info-header {
  padding-top: 10px;
  color: #4aae9b;
  justify-content: space-between;
  background-color: rgb(45, 48, 65);
}

.modal-info-footer {
  justify-content: center;
  background-color: rgb(45, 48, 65);
}

.modal-info-body {
  position: relative;
  padding-bottom: 10px;
  background-color: rgb(45, 48, 65);
}

.btn-close {
  border: none;
  padding: 50px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-green {
  background: #4aae9b;
  border-radius: 2px;
  width: 400px;
  height: 40px;
  font-size: 20px;
}

.modal-info-fade-enter,
.modal-info-fade-leave-active {
  opacity: 0;
}

.modal-info-fade-enter-active,
.modal-info-fade-leave-active {
  transition: opacity 0.3s ease;
}

h2 {
  font-size: 1em;
  color: white;
  margin: 0;
}
</style>
